import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
export const ContainerInfo = styled.div`
  background: #f8f8f8;
  border-radius: 4px;
  padding: 0.5rem;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
`;

export const AreaButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;